import { render, staticRenderFns } from "./DistributionTag.vue?vue&type=template&id=09c10fe8&scoped=true"
import script from "./DistributionTag.vue?vue&type=script&lang=js"
export * from "./DistributionTag.vue?vue&type=script&lang=js"
import style0 from "./DistributionTag.vue?vue&type=style&index=0&id=09c10fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c10fe8",
  null
  
)

export default component.exports